export function getCurrentTimezoneIANA() {
  return Intl.DateTimeFormat().resolvedOptions().timeZone;
}
